"use strict";

var _possibleConstructorReturn = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var pagination_1 = require("./pagination");

var class_validator_1 = require("class-validator");

var country_1 = require("./country");

var NewsTypes;

(function (NewsTypes) {
  NewsTypes["News"] = "news";
  NewsTypes["Information"] = "information";
})(NewsTypes = exports.NewsTypes || (exports.NewsTypes = {}));

var NewsPublicLightDTO = function NewsPublicLightDTO() {
  _classCallCheck(this, NewsPublicLightDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], NewsPublicLightDTO.prototype, "id", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], NewsPublicLightDTO.prototype, "title", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], NewsPublicLightDTO.prototype, "introduction", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], NewsPublicLightDTO.prototype, "isInformation", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], NewsPublicLightDTO.prototype, "picture", void 0);

__decorate([class_validator_1.IsDateString(), __metadata("design:type", Date)], NewsPublicLightDTO.prototype, "createDate", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], NewsPublicLightDTO.prototype, "slug", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], NewsPublicLightDTO.prototype, "titleTag", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], NewsPublicLightDTO.prototype, "metaDescription", void 0);

__decorate([class_validator_1.IsString({
  each: true
}), __metadata("design:type", Array)], NewsPublicLightDTO.prototype, "tags", void 0);

__decorate([class_validator_1.IsEnum(country_1.Country), __metadata("design:type", String)], NewsPublicLightDTO.prototype, "country", void 0);

exports.NewsPublicLightDTO = NewsPublicLightDTO;

var NewsPublicDTO =
/*#__PURE__*/
function (_NewsPublicLightDTO) {
  _inherits(NewsPublicDTO, _NewsPublicLightDTO);

  function NewsPublicDTO() {
    _classCallCheck(this, NewsPublicDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(NewsPublicDTO).apply(this, arguments));
  }

  return NewsPublicDTO;
}(NewsPublicLightDTO);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], NewsPublicDTO.prototype, "content", void 0);

exports.NewsPublicDTO = NewsPublicDTO;

var NewsPrivateDTO =
/*#__PURE__*/
function (_NewsPublicDTO) {
  _inherits(NewsPrivateDTO, _NewsPublicDTO);

  function NewsPrivateDTO() {
    _classCallCheck(this, NewsPrivateDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(NewsPrivateDTO).apply(this, arguments));
  }

  return NewsPrivateDTO;
}(NewsPublicDTO);

__decorate([class_validator_1.IsDateString(), class_validator_1.IsOptional(), __metadata("design:type", Date)], NewsPrivateDTO.prototype, "deleteDate", void 0);

exports.NewsPrivateDTO = NewsPrivateDTO;

var NewsCreationDTO = function NewsCreationDTO() {
  _classCallCheck(this, NewsCreationDTO);
};

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], NewsCreationDTO.prototype, "title", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], NewsCreationDTO.prototype, "introduction", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], NewsCreationDTO.prototype, "content", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], NewsCreationDTO.prototype, "isInformation", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.Length(0, 255), __metadata("design:type", String)], NewsCreationDTO.prototype, "slug", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], NewsCreationDTO.prototype, "picture", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.Length(0, 255), class_validator_1.IsOptional(), __metadata("design:type", String)], NewsCreationDTO.prototype, "titleTag", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.Length(0, 1000), class_validator_1.IsOptional(), __metadata("design:type", String)], NewsCreationDTO.prototype, "metaDescription", void 0);

__decorate([class_validator_1.IsString({
  each: true
}), __metadata("design:type", Array)], NewsCreationDTO.prototype, "tags", void 0);

__decorate([class_validator_1.IsEnum(country_1.Country), __metadata("design:type", String)], NewsCreationDTO.prototype, "country", void 0);

exports.NewsCreationDTO = NewsCreationDTO;

var NewsUpdateDTO = function NewsUpdateDTO() {
  _classCallCheck(this, NewsUpdateDTO);
};

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], NewsUpdateDTO.prototype, "title", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], NewsUpdateDTO.prototype, "introduction", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], NewsUpdateDTO.prototype, "content", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], NewsUpdateDTO.prototype, "isInformation", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.Length(0, 255), class_validator_1.IsOptional(), __metadata("design:type", String)], NewsUpdateDTO.prototype, "slug", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], NewsUpdateDTO.prototype, "picture", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.Length(0, 255), class_validator_1.IsOptional(), __metadata("design:type", String)], NewsUpdateDTO.prototype, "titleTag", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.Length(0, 1000), class_validator_1.IsOptional(), __metadata("design:type", String)], NewsUpdateDTO.prototype, "metaDescription", void 0);

__decorate([class_validator_1.IsString({
  each: true
}), __metadata("design:type", Array)], NewsUpdateDTO.prototype, "tags", void 0);

__decorate([class_validator_1.IsEnum(country_1.Country), class_validator_1.IsOptional(), __metadata("design:type", String)], NewsUpdateDTO.prototype, "country", void 0);

__decorate([class_validator_1.IsDateString(), class_validator_1.IsOptional(), __metadata("design:type", Date)], NewsUpdateDTO.prototype, "deleteDate", void 0);

exports.NewsUpdateDTO = NewsUpdateDTO;

var NewsFilterDTO = function NewsFilterDTO() {
  _classCallCheck(this, NewsFilterDTO);
};

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], NewsFilterDTO.prototype, "type", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", Array)], NewsFilterDTO.prototype, "tags", void 0);

__decorate([class_validator_1.IsEnum(country_1.Country), class_validator_1.IsOptional(), __metadata("design:type", Array)], NewsFilterDTO.prototype, "countries", void 0);

exports.NewsFilterDTO = NewsFilterDTO;

var NewsPaginationResponse =
/*#__PURE__*/
function (_pagination_1$Paginat) {
  _inherits(NewsPaginationResponse, _pagination_1$Paginat);

  function NewsPaginationResponse() {
    _classCallCheck(this, NewsPaginationResponse);

    return _possibleConstructorReturn(this, _getPrototypeOf(NewsPaginationResponse).apply(this, arguments));
  }

  return NewsPaginationResponse;
}(pagination_1.PaginationResponse);

exports.NewsPaginationResponse = NewsPaginationResponse;